import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectDragAndDropService } from '../../annotation-list/object-drag-and-drop.service';

@Component({
  selector: 'h3-object-list-item-drop-areas',
  templateUrl: './object-list-item-drop-areas.component.html',
  styleUrls: ['./object-list-item-drop-areas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ObjectListItemDropAreasComponent implements OnInit {
  @Input({ required: true }) objectId!: number;
  canBeDroppedOn$!: Observable<boolean>;
  willReorderBefore$!: Observable<boolean>;
  willReorderAfter$!: Observable<boolean>;

  private dragAndDropService = inject(ObjectDragAndDropService);

  ngOnInit() {
    this.canBeDroppedOn$ = this.dragAndDropService.canBeDroppedOn$(
      this.objectId,
    );
    this.willReorderBefore$ = this.dragAndDropService.willReorderBefore$(
      this.objectId,
    );
    this.willReorderAfter$ = this.dragAndDropService.willReorderAfter$(
      this.objectId,
    );
  }

  setTargetNestingObject() {
    this.dragAndDropService('targetNestingObjectId').set(this.objectId);
  }

  removeTargetNestingObject() {
    this.dragAndDropService('targetNestingObjectId').set(null);
  }

  registerAsNextObjectForReordering() {
    this.dragAndDropService.setReorderingUsingNextObjectId(this.objectId);
  }

  registerAsPreviousObjectForReordering() {
    this.dragAndDropService.setReorderingUsingPreviousObjectId(this.objectId);
  }

  cancelReordering() {
    this.dragAndDropService('objectReordering').delete();
  }
}
